/* Página inicial do Fórum, onde são listados os tópicos de discussão. Os usuários podem clicar em um tópico para ver as postagens e respostas relacionadas.
*/

import ListaForum from "../../componentes/ListaForum";


const ListagemForum = () => {
    return (
        <div>  
            <div className="container-fluid mt-3">
                <ListaForum />
            </div>    
        </div>
    )}

export default ListagemForum;